export default "__VITE_ASSET__gD0Dg1QJ__"